import { H4, Image, theme } from '@ahmdigital/ui';
import React from 'react';
import styled from 'styled-components';

import mozo from './images/mozo-award.svg';
import weMoney from './images/we-money-award.svg';

const { media, mediaQueries } = theme;

const AwardsWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 3rem;

  ${mediaQueries.above(media.md)} {
    align-items: flex-start;
    padding-left: 1.5rem;
  }

  ${mediaQueries.above(media.lg)} {
    padding: 0;
    margin-top: 1rem;
  }
`;

const ImagesWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-bottom: 1rem;
`;

const Awards = () => (
  <AwardsWrapper>
    <ImagesWrapper>
      <Image src={weMoney.src} alt="WeMoney award" />
      <Image src={mozo.src} alt="Mozo award" />
    </ImagesWrapper>
    <H4 variant={['center', 'simpleBit']}>ahm’s travel insurance is award winning!</H4>
  </AwardsWrapper>
);

export default Awards;
